export default {
    AddAppointment: "add_appointment",
    ViewAppointments: "view_appointments",
    ViewAppointment: "view_appointment",
    ModifyAppointments: "modify_appointments",
    CancelAppointments: "cancel_appointments",
    ApprovAappointments: "approve_appointments",
    ViewClinic: "view_clinic",
    ViewClinics: "view_clinics",
    UpdateClinic: "update_clinic",
    AddClinic: "add_clinic",
    DeleteClinic: "delete_clinic",
    AddMaster: "add_master",
    UpdateMaster: "update_master",
    ViewMaster: "view_master",
    DeleteMaster: "delete_master",
    AddDoctor: "add_doctor",
    ViewDoctor: "view_doctor",
    ViewDoctors: "view_doctors",
    UpdateDoctor: "update_doctor",
    DeleteDoctor: "delete_doctor",
    UploadReports: "upload_reports",
    ViewReports: "view_reports",
    UpdateReports: "update_reports",
    DeleteReports: "delete_reports",
    AddPatient: "add_patient",
    ViewPatient: "view_patient",
    ViewPatients: "view_patients",
    UpdatePatient: "update_patient",
    DeletePatient: "delete_patient",
    AddUser: "add_user",
    ViewUsers: "view_users",
    UpdateUser: "update_user",
    DeleteUser: "delete_user",
    AddRole: "add_role",
    ViewRoles: "view_roles",
    UpdateRole: "update_role",
    DeleteRole: "delete_role",
    AddPermission: "add_permission",
    ViewPermissions: "view_permissions",
    UpdatePermission: "update_permission",
    DeletePermission: "delete_permission",
    ViewAnalytics: "view_analytics",
    SendEmail: "send_email",
    SendMessage: "send_message",
    ReminderEmail: "reminder_email",
    ReminderMessage: "reminder_message",
    ViewAuditTrail: "view_audit_trail",
    ViewChat: "view_chat",
    SendChat: "send_chat",

}


// WEBPACK FOOTER //
// ./src/util/globalPermissions.js